export default __webpack_public_path__ + "static/media/478.bde2b3c0.gif";